module.exports = __webpack_public_path__ + "img/SEK.fd682a8f.svg";